import axiosV2Instance from './axiosV2Instance';

export interface Permission {
  id: number;
  code: string;
  description: string;
  createdAt?: string;
}

export interface SiteMemberPermission {
  id: number;
  siteMemberId: number;
  permissionId: number;
  grantedAt: string;
  grantedBy?: number | null;
  revokedAt?: string | null;
  revokedBy?: number | null;
  permissionCode?: string;
  permissionName?: string;
  permissionDescription?: string;
}

export interface GrantPermissionRequest {
  permissionCode: string;
}

class SiteMemberPermissionsApi {
  /**
   * Получить все доступные права в системе
   */
  async getAllPermissions(): Promise<Permission[]> {
    try {
      const response = await axiosV2Instance.get<Permission[]>('/permissions');
      return response.data;
    } catch (error) {
      console.error('Error fetching all permissions:', error);
      throw error;
    }
  }

  /**
   * Получить права конкретного участника объекта
   */
  async getMemberPermissions(siteId: number, memberId: number): Promise<SiteMemberPermission[]> {
    try {
      console.log(`API: Getting view permissions for site ${siteId}, member ${memberId}`);
      const response = await axiosV2Instance.get<SiteMemberPermission[]>(
        `/sites/${siteId}/members/${memberId}/permissions`
      );
      console.log('API: View permissions response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error fetching member permissions:', error);
      throw error;
    }
  }

  /**
   * Предоставить право участнику
   */
  async grantPermission(
    siteId: number,
    memberId: number,
    permissionCode: string
  ): Promise<number> {
    try {
      const response = await axiosV2Instance.post<{ id: number }>(
        `/sites/${siteId}/members/${memberId}/permissions`,
        { permissionCode }
      );
      return response.data.id;
    } catch (error) {
      console.error('Error granting permission:', error);
      throw error;
    }
  }

  /**
   * Отозвать право у участника
   */
  async revokePermission(
    siteId: number,
    memberId: number,
    permissionCode: string
  ): Promise<void> {
    try {
      await axiosV2Instance.delete(
        `/sites/${siteId}/members/${memberId}/permissions/${permissionCode}`
      );
    } catch (error) {
      console.error('Error revoking permission:', error);
      throw error;
    }
  }
}

export const siteMemberPermissionsApi = new SiteMemberPermissionsApi();
